<template>
  <v-container fluid class="holiday-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/holiday/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end mt-3 mt-md-0">

            </v-col>
            <v-col cols="12" class="d-flex justify-end mt-3">

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="holidays-table"
              show-select
              single-select
              item-key="_id"
              sort-by="holidaydate"
              :footer-props="footer"
              :headers="headers"
              :items="holidays"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Holiday?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteHoliday.holidayname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteHoliday)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.holidayname="{ item }">
                <p class="two-line"><strong>{{ item.holidayname }}</strong></p>
                <p class="two-line">{{ item.holidaynameinfo  }}</p>
              </template>
              <template v-slot:item.holidaystatus="{ item }">
                <v-chip
                  :color="!item.holidaystatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.holidaystatus }}
                </v-chip>
              </template>
              <template v-slot:item.holidaydate="{ item }">
                {{ new Date(item.holidaydate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'long' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'holidayList',
  data() {
    return {
      snackbar: null,
      dialog: false,
      deleteHoliday: {},
      headers: [
        { text: 'Date', value: 'holidaydate' },
        { text: 'Type', value: 'holidaytype' },
        { text: 'Code', value: 'holidaycode' },
        { text: 'Name', value: 'holidayname' },
        { text: 'Status', value: 'holidaystatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
      switch1: true,
      holidayid: ['admin', 'holiday'],
    }
  },

  computed: {
    ...mapState('Holiday', ['holidays', 'isReceiving', 'isDeleting', 'idToDelete', 'holidaysMessage', 'isUpdating']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit holiday'
    },
  },
  created () {
    this.getHolidaysRequest()
  },
  methods: {
    ...mapActions('Holiday', ["getHolidaysRequest","deleteHolidayRequest","updateHolidayRequest","createHolidayRequest"]),
    editItem(item) {
      this.$router.push({ name: 'HolidayEdit', params: item })
    },
    deleteItem(item) {
      this.deleteHolidayRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteHoliday = {
        _id: item._id,
        holidayname: item.holidayname,
      }
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
